import type { BaseThemePrepared } from '@archipro-design/aria';
import { productTheme } from '@archipro-design/aria';
import type { Directory } from '../types';

export const getThemeByHoverNav = (
    navType?: Directory,
): BaseThemePrepared | undefined => {
    switch (navType) {
        case 'project':
        case 'professional':
        case 'article':
        case 'product':
            return productTheme;
        default:
            return undefined;
    }
};
